<template>
  <div class="contents">
    <NuxtLoadingIndicator color="#FF7F31" />
    <slot />
  </div>
</template>
